import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface TomeDto {
	id: string;
	worldId: string;
	poiId: string | null;
	poiName: string | null;
	regionName: string | null;
	name: string;
	description: string | null;
	author: string | null;
	rarity: string | null;
	imageAssetId: string | null;
	mapAssetId: string | null;
	pdfAssetId: string | null;
	foundryId: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface TomesListResponse {
	tomes: TomeDto[];
	total: number;
}

export interface TomeGetResponse {
	tome: TomeDto;
}

export interface UpsertTomeRequest {
	name: string;
	poiId?: string | null;
	description?: string | null;
	author?: string | null;
	rarity?: string | null;
	foundryId?: string | null;
	imageAssetId?: string | null;
	mapAssetId?: string | null;
	pdfAssetId?: string | null;
}

@Injectable({ providedIn: 'root' })
export class TomesService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, q?: string): Observable<TomesListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (q) params = params.set('q', q);
		return this.http.get<TomesListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tomes`, { params });
	}

	get(worldId: string, tomeId: string): Observable<TomeGetResponse> {
		return this.http.get<TomeGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tomes/${tomeId}`);
	}

	create(worldId: string, request: UpsertTomeRequest): Observable<TomeGetResponse> {
		return this.http.post<TomeGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tomes`, {
			Name: request.name,
			PoiId: request.poiId ?? null,
			Description: request.description ?? null,
			Author: request.author ?? null,
			Rarity: request.rarity ?? null,
			FoundryId: request.foundryId ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			MapAssetId: request.mapAssetId ?? null,
			PdfAssetId: request.pdfAssetId ?? null,
		});
	}

	update(worldId: string, tomeId: string, request: UpsertTomeRequest): Observable<TomeGetResponse> {
		return this.http.put<TomeGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tomes/${tomeId}`, {
			Name: request.name,
			PoiId: request.poiId ?? null,
			Description: request.description ?? null,
			Author: request.author ?? null,
			Rarity: request.rarity ?? null,
			FoundryId: request.foundryId ?? null,
			ImageAssetId: request.imageAssetId ?? null,
			MapAssetId: request.mapAssetId ?? null,
			PdfAssetId: request.pdfAssetId ?? null,
		});
	}

	delete(worldId: string, tomeId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/tomes/${tomeId}`);
	}
}
